module.exports = __webpack_public_path__ + "img/question-filled.4a2e3a1d.svg";